

/**
 * Sets properties on person to indicate whether driver license upload was erroneous
 * and to indicate that an attempt at scanning license has been made
 * @param {Object} person
 * @param {Object} driverLicense
 */
function setLicenseUploadProperties(person, driverLicense) {
    person.errorUploading = Object.keys(driverLicense).length === 0;
    person.isDriverLicenseScanned = true;
}

/**
 * Assign information retrieved from driver license barcode to the driver
 * @param {Object} driver
 * @param {Object} driverLicense
 */
function fillDriverInfo(driver, driverLicense) {
    var person = driver.person;
    Object.keys(driverLicense).forEach(function (key) {
        if (driver.hasOwnProperty(key)) {
            driver[key].value = driverLicense[key];
        }
        if (person.hasOwnProperty(key)) {
            person[key].value = driverLicense[key];
        }
    });
}

/**
 * Assign information retrieved from driver license barcode to the contact. If scanned license has a different
 * postal code from the product availability postal code, the primary address of the scanned license will be ignored.
 * @param {Object} contact
 * @param {Object} driverLicense
 * @param {Boolean} skipAddress
 */
function fillContactInfo(contact, driverLicense, skipAddress) {
    if (skipAddress) {
        delete driverLicense.primaryAddress;
        delete driverLicense.licenseState;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(driverLicense)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (contact.hasOwnProperty(key)) {
                contact[key].value = driverLicense[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

export default (function () {
    return {
        setLicenseUploadProperties: setLicenseUploadProperties,
        fillDriverInfo: fillDriverInfo,
        fillContactInfo: fillContactInfo
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/util/DriverLicenseUtil.js
// module id = 2179
// module chunks = 0